module.exports = __webpack_public_path__ + "static/media/logo-text-color.c0ba8257.png";